import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useMemo } from "react";
import type { ScheduleChangeLogListQueryDTO } from "../../domain/contracts/schedule-logs";
import { useScheduleChangeLogsQuery } from "../api/queries";
import { ScheduleChangeLogFilter } from "../ui/ScheduleChangeLogFilter";
import { ScheduleChangeLogTable } from "../ui/ScheduleChangeLogTable";
import { ScheduleChangeLogToolbar } from "../ui/ScheduleChangeLogToolbar";

export function ScheduleChangeLogsPage() {
  const nav = useNavigate({ from: "/app/classes/schedule-logs" });
  const search = useSearch({
    from: "/app/classes/schedule-logs",
  }) as Partial<ScheduleChangeLogListQueryDTO> & {
    limit?: number;
    offset?: number;
  };

  const query = useMemo<ScheduleChangeLogListQueryDTO>(
    () => ({
      limit: search.limit ?? 20,
      offset: search.offset ?? 0,
      sort: search.sort,
      sessionType: search.sessionType,
      changeType: search.changeType,
      changedBy: search.changedBy,
      dateFrom: search.dateFrom,
      dateTo: search.dateTo,
      reason: search.reason,
    }),
    [
      search.limit,
      search.offset,
      search.sort,
      search.sessionType,
      search.changeType,
      search.changedBy,
      search.dateFrom,
      search.dateTo,
      search.reason,
    ],
  );

  const { data, isLoading, refetch, isRefetching } =
    useScheduleChangeLogsQuery(query);

  const items = data?.data ?? [];
  const total = data?.meta?.total ?? 0;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ບັນທຶກການປ່ຽນແປງຕາຕະລາງ" },
          ]}
        />
      </Header>

      <Main>
        <ScheduleChangeLogToolbar
          onRefresh={() => refetch()}
          isRefetching={isRefetching}
        />
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ScheduleChangeLogFilter />
          <ScheduleChangeLogTable
            isLoading={isLoading}
            data={items}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={total}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onView={(id) => {
              nav({
                to: "/app/classes/schedule-logs/$id",
                params: { id },
                search: { ...search },
              });
            }}
          />
        </div>
      </Main>
    </>
  );
}
